import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
/**
 * Navigation bar, always shown below
 */
export class NavigationBarComponent {
  RoutesKeys = RoutesKeys;
  private _home: boolean = false;
  homeLabel = 'home';
  sideMenuItems: SideMenuItems = new SideMenuItems();
  navItems: string[][] = [];

  /**
   * @constructor
   */
  constructor(public translationService: TranslationService) {
    this.navItems = this.sideMenuItems.navigationBarItems;
    for (const nav of this.navItems) {
      this.translationService.translateString(nav[0]).then((translated) => {
        nav[2] = translated;
      });
    }
  }
  /**
   * Whether home is active or not
   */
  @Input()
  get home(): boolean {
    return this._home;
  }

  /**
   * Sets this home item as active
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set home(value: any) {
    this._home = coerceBooleanProperty(value);
  }
}
